/**
 * Privy 2 (Background Check) API Client
 *
 * GW-6769: Atomic switch to gw-signals-api /v1/verifications/background-check routes.
 * No fallback to gw-functions /privy/2/* routes.
 */

import { getConfig } from '@/config/runtimeConfig';

import { BaseApiClient } from './baseApiClient';

/**
 * Response from POST /v1/verifications/background-check (gw-signals-api)
 */
interface BgcInitiateResponse {
  invitationUrl: string;
}

/**
 * Response from GET /v1/verifications/background-check/status (gw-signals-api)
 */
interface BgcStatusResponse {
  hasActiveSession: boolean;
  invitationUrl?: string;
  sessionStatus?: string;
}

class Privy2ApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURLFactory: () => getConfig().signalsApiBaseUrl ?? getConfig().apiBaseUrl,
      suppressSessionExpired: true,
    });
  }

  /**
   * Initiate a Checkr background check session
   * POST /v1/verifications/background-check
   *
   * @returns Promise<BgcInitiateResponse> - reportId and sessionId
   * @throws ApiError on 401 (unauthenticated) or other errors
   */
  async initiatePrivy2(): Promise<BgcInitiateResponse> {
    return this.post<BgcInitiateResponse>('/v1/verifications/background-check');
  }

  /**
   * Fetch the current background check session status
   * GET /v1/verifications/background-check/status
   *
   * @returns Promise<BgcStatusResponse> - sessionStatus and reportId
   * @throws ApiError on 401 (unauthenticated) or 404 (no session)
   */
  async getPrivy2Status(): Promise<BgcStatusResponse> {
    return this.get<BgcStatusResponse>('/v1/verifications/background-check/status');
  }
}

export const privy2Api = new Privy2ApiClient();
